// extracted by mini-css-extract-plugin
export default {"wmPaginationSummary":"PaginationSummary_wmPaginationSummary__yjzij"};